export enum WageExtraType {
  Unknown = 0,
  Salary = 1,
  Reimbursement = 2,
  BonusReferral = 3,
  BonusOther = 4,
  EmployeeAdjWage = 5,
  PerDiem = 6,
  MiscWork = 7,
  BonusSafety = 8,

  ReimbursementHealthDeduction = 10,
  ReimbursementHealthCredit = 11,
  EmployeeAdjDropAndHook = 100
}

export const WageExtraTypeMapping: Record<WageExtraType, string> = {
  [WageExtraType.Unknown]: '-- Select Entry --',
  [WageExtraType.Salary]: 'Salary',
  [WageExtraType.Reimbursement]: 'Reimbursement',
  [WageExtraType.BonusReferral]: 'Bonus - Referral',
  [WageExtraType.BonusOther]: 'Bonus - Other',
  [WageExtraType.EmployeeAdjWage]: 'Employee Adj. - Wage',
  [WageExtraType.PerDiem]: 'Per Diem',
  [WageExtraType.MiscWork]: 'Misc Work',
  [WageExtraType.ReimbursementHealthDeduction]: 'Health Care Deduction',
  [WageExtraType.ReimbursementHealthCredit]: 'Health Care Credit',
  [WageExtraType.BonusSafety]: 'Bonus - Safety',
  [WageExtraType.EmployeeAdjDropAndHook]: 'Employee Adj. - D&H'
};
